import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";

import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields, LogicButton } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";

import { PaqueteDocumentacionList } from "./componentes/paquetes/list";
import { SobreDocumentacionList } from "./componentes/sobres/list";
import { DestinoSucursal } from "./componentes/destinosucursal";
import { OrigenSucursal } from "./componentes/origensucursal";
import { AlertaDestinoDiferente } from "./componentes/alertaDestinoDiferente";
type Entity = models.DocumentacionModel;

interface Props {
    value: Entity;
    onChange: (x: Entity) => void;
    permisos: models.Rol;
    session: models.Session;
}

export function rules(): validation.Rules<models.DocumentacionServicios> {
    const reglaPaqueteSobre = (x: models.DocumentacionServicios) => x.Paquetes.length == 0 && x.Sobres.length == 0 ? "Obligatorio al menos un paquete o sobre" : true;
    return {
        IdContactoOrigen: validation.required,
        Paquetes: reglaPaqueteSobre,
        Sobres: reglaPaqueteSobre,
    };
}



/**Vista de la captura de los datos de documentación */
export class Documentacion extends React.PureComponent<Props> {
    serviciosProps = () => ({
        value: this.props.value.servicios,
        onChange: (x: models.DocumentacionServicios) => this.props.onChange({ ... this.props.value, servicios: x })
    });

    errors = () => validation.getErrors(rules(), this.props.value.servicios);
    getFieldServicios = kea.formfields(this.serviciosProps, this.errors);
    getField = formfields(() => this.props);

    onServiciosChange = (x: models.DocumentacionServicios) => {
        this.props.onChange({ ... this.props.value, servicios: x });
    }

    permisos = (props: Props) => props.permisos;
    session = (props: Props) => props.session;
    /**Si tiene permiso de documentar cualquier origen no se dbene de filtrar las direcciones */
    documentarCualquierOrigen = (props: Props) => props.permisos.Documentacion.DocumentarCualquierOrigen;
    permisosModificarRecoleccionADomicilio = (props: Props) => props.permisos.Documentacion.VerModificarCheckBoxRecoleccionDomicilioEnDocumentacion;
    permisoAsignarSeguroDefault = (props: Props) => props.permisos.Documentacion.AsignarSeguroDefault;
    permisoSucursalUsuario = (props: Props) => props.permisos.Documentacion.DocumentarCualquierSucursalOrigen;
    idClienteUsuario = createSelectorRx(this.permisos, this.session, (permisos, session) => permisos.Documentacion.DocumentarCualquierClienteOrigen ? undefined : (session.IdCliente || undefined));
    idSucursalUsuario = createSelectorRx(this.session, session => (session.IdSucursal || undefined));
    idDireccionUsuario = createSelectorRx(this.session, session => (session.IdDireccionOrigen || undefined));

    render() {
        const { getField, getFieldServicios } = this;
        const props = this.props;

        const Paquetes = getFieldServicios(PaqueteDocumentacionList);
        const Sobres = getFieldServicios(SobreDocumentacionList);
        const Destino = getField(selectores.DireccionClienteSelector);
        const idClienteUsuario = this.idClienteUsuario(this.props);
        const idSucursalUsuario = this.idSucursalUsuario(this.props);
        const documentarCualquierOrigen = this.documentarCualquierOrigen(this.props);
        const permisosModificarRecoleccionADomicilio = this.permisosModificarRecoleccionADomicilio(this.props);
        const permisoAsignarSeguroDefault = this.permisoAsignarSeguroDefault(this.props);
        const cualquierSucursalorigen = this.permisoSucursalUsuario(this.props);

        return (
            <div>
                {kea.autogrid(6, [
                    <OrigenSucursal 
                        value={this.props.value.servicios} 
                        onChange={this.onServiciosChange} 
                        idDireccionUsuario={this.idDireccionUsuario(this.props)}
                        idClienteUsuario={idClienteUsuario} 
                        idSucursalUsuario={idSucursalUsuario} 
                        documentarCualquierOrigen={documentarCualquierOrigen} 

                    />,
                    <div>
                        <DestinoSucursal value={this.props.value} onChange={this.props.onChange} idClienteUsuario={idClienteUsuario} />
                        <AlertaDestinoDiferente value={this.props.value} onChange={this.props.onChange} />
                    </div>
                ])}

                {kea.autogrid(6, [
                    <Paquetes field="Paquetes" session = {this.props.session} idDireccionDestino={this.props.value.IdDireccionDestino} idSucursalDestino={this.props.value.IdSucursalDestino} puedeModificarRecoleccion={permisosModificarRecoleccionADomicilio} asignarSeguroDefault={permisoAsignarSeguroDefault} />,
                    <Sobres field="Sobres" idDireccionDestino={this.props.value.IdDireccionDestino} idSucursalDestino={this.props.value.IdSucursalDestino} puedeModificarRecoleccion={permisosModificarRecoleccionADomicilio} />
                ])}
            </div >
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/guias/documentacion/documentacion.tsx